import { mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters(["catalogues"])
  },
  methods: {
    getCatalogueValueById(descId, value) {
      if (!value) {
        return null
      }
      const found = this.catalogues.find((c) => c.descId == descId)
      if (found) {
        const valeur = found.valeurs.find((c) => c.value == value)
        if (valeur) {
          return valeur
        }
      }
      return null
    },
    getCatalogueValueByCode(descId, code) {
      if (!code) {
        return null
      }
      const found = this.catalogues.find((c) => c.descId == descId)
      if (found) {
        const valeur = found.valeurs.find((c) => c.code == code)
        if (valeur) {
          return valeur
        }
      }
      return null
    },
    getCatalogueCodeById(descId, value) {
      if (!value) {
        return null
      }
      const catalogue = this.getCatalogueValueById(descId, value)

      return catalogue ? catalogue.code : null
    },
    estOui(value) {
      if (!value) {
        return false
      }
      return this.getCatalogueCodeById(231, value) == "1"
    },
    estNon(value) {
      if (!value) {
        return false
      }
      return this.getCatalogueCodeById(231, value) == "2"
    },
    estNonNeuropsy(value) {
      if (!value) {
        return false
      }
      return this.getCatalogueCodeById(6013, value) == "3"
    },
    codePays(value) {
      const pays = this.getCatalogueValueById(303, value)
      return pays ? pays.code : null
    },
    codeProvince(value) {
      const province = this.getCatalogueValueById(313, value)
      return province ? province.code : null
    },
    paysEstUSouCA(value) {
      const pays = this.getCatalogueValueById(303, value)
      return pays ? pays.code == "CA" || pays.code == "US" : false
    },
    textPays(value) {
      const pays = this.getCatalogueValueById(303, value)

      return pays ? pays.text : ""
    },
    textProvince(value) {
      const province = this.getCatalogueValueById(313, value)
      return province ? province.text : ""
    }
  }
}